import { ReactNode, createContext, useContext } from 'react';
import {
  WATCH_CONFIG_TABLE_NAME,
  WATCH_CONFIG_TABLE_ORDER,
  WatchConfigTables,
  useWatchSocketConfigTables,
} from 'greener-ui-library';
import { useWatchSocketData } from './WatchSocketContext';

const ALL_CONFIG_TABLES = [...WATCH_CONFIG_TABLE_ORDER, WATCH_CONFIG_TABLE_NAME.ExternalSolarInverterConfig];

const WatchConfigTablesContext = createContext<WatchConfigTables | null>(null);

export const WatchConfigTablesProvider = ({ children }: { children: ReactNode }) => {
  const { isConnected, messages, requestConfig } = useWatchSocketData();
  const configTables = useWatchSocketConfigTables(ALL_CONFIG_TABLES, requestConfig, isConnected, messages);

  return <WatchConfigTablesContext.Provider value={configTables}>{children}</WatchConfigTablesContext.Provider>;
};

export const useWatchConfigTables = (): WatchConfigTables => {
  const context = useContext(WatchConfigTablesContext);

  if (!context) {
    throw new Error('useWatchConfigTables must be used inside a WatchConfigTablesProvider');
  }

  return context;
};
